import { push } from 'connected-react-router'
import respond from './utilities/respond'
import at from '../../actionTypes'

const appActions = {
	appShowTopBar: dispatch => showTopBar => dispatch(respond(at.APP_SHOW_TOP_BAR, { showTopBar })),
	appBottomBarValue: dispatch => bottomBarValue => dispatch(respond(at.APP_BOTTOM_BAR_VALUE, { bottomBarValue })),
	appBottomNavValue: dispatch => bottomNavValue => dispatch(respond(at.APP_BOTTOM_NAV_VALUE, { bottomNavValue })),
	appHeading: dispatch => heading => dispatch(respond(at.APP_HEADING, { heading })),
	appBackButtonFunction: dispatch => backButtonFunction => dispatch(respond(at.APP_BACK_BUTTON_FUNCTION, { backButtonFunction })),
	appAddContextMenu: dispatch => contextMenu => dispatch(respond(at.appAddContextMenu, { contextMenu })),
	appShowBottomBar: dispatch => showBottomBar => dispatch(respond(at.APP_SHOW_BOTTOM_BAR, { showBottomBar })),
	appShowBottomNavBar: dispatch => showBottomNavBar => dispatch(respond(at.APP_SHOW_BOTTOM_NAV_BAR, { showBottomNavBar })),
	appBottomNavBarHandleClick: dispatch => bottomNavBarHandleClick => dispatch(respond(at.APP_BOTTOM_NAV_BAR_HANDLE_CLICK, { bottomNavBarHandleClick })),
	appBottomNavBarLabelNext: dispatch => bottomNavBarLabelNext => dispatch(respond(at.APP_BOTTOM_NAV_BAR_LABEL_NEXT, { bottomNavBarLabelNext })),
	appNextButtonIsLoading: dispatch => nextButtonIsLoading => dispatch(respond(at.APP_NEXT_BUTTON_IS_LOADING, { nextButtonIsLoading })),
	appDrawerOpen: dispatch => drawerOpen => dispatch(respond(at.APP_DRAWER_OPEN, { drawerOpen })),
	appPageLoaded: dispatch => pageHasLoaded => dispatch(respond(at.APP_PAGE_LOADED, { pageHasLoaded })),
	appShowSnackbar: dispatch => showSnackbar => dispatch(respond(at.APP_SHOW_SNACKBAR, { showSnackbar })),
	// TODO: this is why you don't want to mix dispatch curried, and straight action creators
	appMessageInternal: (messageType, message) => respond(at.APP_MESSAGE, { messageType, message }),
	appMessage: dispatch => (messageType, message) => dispatch(appActions.appMessageInternal(messageType, message)),
	appRedirect: dispatch => (url) => {
		dispatch(push(url))
		dispatch(respond(at.APP_REDIRECT, { url }))
	},
	appBackgroundImage: dispatch => backgroundImage => dispatch(respond(at.APP_BACKGROUND_IMAGE, { backgroundImage }))
}

export default appActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/appActions.js